/* eslint-disable no-unused-vars */
import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Calendar,
  Video,
  Headphones,
  Users,
  BookOpen,
  Heart,
  DollarSign,
  Sparkles,
  MessageCircle,
  Mic,
  ExternalLink,
  Brain,
  Dumbbell,
  Compass,
  Landmark,
  ArrowRight,
  Check,
  Flame,
  CalendarCheck,
  Quote,
} from 'lucide-react';
import PortalSubPage, { ComingSoonCard } from '../PortalSubPage';
import {
  NEXT_MEETING,
  INTEREST_MAILTO,
  INTEREST_EMAIL,
  CIRCLE_FOCUS,
  CIRCLE_GUEST_SPEAKER,
  CIRCLE_TOPICS,
  CIRCLE_PRICE,
  getReflectionForOffset,
} from '../../data/portalData';

export function PortalMeditation() {
  return (
    <PortalSubPage
      eyebrow="Guided Stillness"
      title={<>Sit. Breathe. <span className="italic text-[#D4AF37]">Return.</span></>}
      intro="Short guided practices to reset the nervous system. Start with five minutes. Build a rhythm."
      icon={Headphones}
    >
      <div className="rounded-2xl bg-[#111111] border border-white/10 overflow-hidden">
        <div className="aspect-video bg-black">
          <iframe
            className="w-full h-full"
            src="https://www.youtube.com/embed/inpok4MKVLM"
            title="Guided Meditation"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            data-testid="meditation-video"
          />
        </div>
        <div className="p-5">
          <h3 className="font-cormorant text-xl font-medium text-white">
            5-Minute Reset · Presence Practice
          </h3>
          <p className="text-zinc-500 font-manrope text-sm mt-1">
            A short breath-based reset for the middle of your day.
          </p>
        </div>
      </div>

      <ComingSoonCard note="A full library of Reset-branded meditations is on the way. Curated by David G." />
    </PortalSubPage>
  );
}
